/**
 * Created by dzuniga on 2/4/15.
 */
define(function(require) {
  const CommerceItemCollection = require('common/collections/commerce_item');
  const BaseController = require('common/controllers/base');
  const CartModel = require('common/models/cart');
  const { isUndefined, map, pick } = require('underscore');
  const { updateCartCountCookie } = require('common/util/cart-helper');
  let _cartModel;

  /**
   * Adds an item to the inner cart model
   * @param {CommerceItem} item - the item to remove. Need id, productId and quantity.
   * @param {Object} onAddItemCallbacks - Success/error callbacks for the model update. i.e.
   *   onAddItemCallbacks -> {
   *      success: function() {},
   *      error: function() {}
   */
  const _addItemToModel = function addItemToCart(item, onAddItemCallbacks) {
    _cartModel.addItem(item, onAddItemCallbacks);
  };

  const _addGiftCertToModel = function addGiftCertToCart(item, onAddItemCallbacks) {
    _cartModel.addGiftCert(item, onAddItemCallbacks);
  };

  /**
   * Removes an item from the inner cart model
   * @param {CommerceItem} item - the item to remove. Need only the id property.
   * @param {Object} onRemoveItemCallbacks - Success/error callbacks for the model update. i.e.
   *   onRemoveItemCallbacks -> {
   *      success: function() {},
   *      error: function() {}
   */
  const _removeItemFromModel = function removeItemFromCart(item, onRemoveItemCallbacks) {
    const data = {
      id: item.get('id'),
    };

    _cartModel.removeItem(data, onRemoveItemCallbacks);
  };

  const _createCartModel = function newEmptyCartModel() {
    return new CartModel({
      commerceItems: new CommerceItemCollection(),
    });
  };

  return BaseController.extend({
    _selectors: {},

    initialize() {
      const self = this;

      if (isUndefined(_cartModel)) {
        _cartModel = _createCartModel();
      }

      $.subscribe('cart:remove-item', self.removeItem, self);
      $.subscribe('cart:count-updated', updateCartCountCookie, self);
    },

    addGiftCert(item, onSuccess, onError) {
      if (!item) {
        return;
      }

      _addGiftCertToModel(item, {
        success(response) {
          onSuccess && onSuccess(response);
        },
        error(jqXHR, textStatus, errorThrown) {
          onError(jqXHR, textStatus, errorThrown);
        },
      });
    },

    addItem(item, onSuccess, onError) {
      if (!item) {
        return;
      }

      _addItemToModel(item, {
        success(response) {
          onSuccess && onSuccess(response);
        },
        error(jqXHR, textStatus, errorThrown) {
          onError(jqXHR, textStatus, errorThrown);
        },
      });
    },

    removeItem(item, onSuccess, onError) {
      if (!item || item.removed) {
        return;
      }

      BC.publish('minicart.before.remove', item, this.getItemListWithWarranties());

      _removeItemFromModel(item, {
        success(response) {
          item.removed = true;
          $.publish('commerce_item:remove', item);
          onSuccess && onSuccess(response);
        },
        error: onError,
      });
    },

    getModel() {
      return _cartModel;
    },

    getItemList() {
      return map(_cartModel.attributes.commerceItems.models, function(item) {
        return pick(item.attributes, 'productId', 'sku');
      });
    },

    getItemListWithWarranties() {
      return map(_cartModel.attributes.commerceItems.models, function(item) {
        return pick(item.attributes, 'sku', 'itemType', 'warrantySku', 'planId');
      });
    },

    refreshModel(onSuccess, onError) {
      _cartModel.fetch({ success: onSuccess, error: onError });
    },
  });
});
